
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("ftTn3", function(module, exports) {
"use strict";
function $b45483ed49b147c3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b45483ed49b147c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b45483ed49b147c3$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $alJys = parcelRequire("alJys");
function $b45483ed49b147c3$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $b45483ed49b147c3$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $b45483ed49b147c3$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($b45483ed49b147c3$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $b45483ed49b147c3$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b45483ed49b147c3$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b45483ed49b147c3$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b45483ed49b147c3$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $b45483ed49b147c3$var$utm = function utm(w, d, s, f, v) {
    w[v] = w[v] || [];
    var e = d.getElementsByTagName(s)[0];
    var j = d.createElement(s);
    j.async = true;
    j.src = f;
    e.parentNode.insertBefore(j, e);
};
var $b45483ed49b147c3$var$fireEvents = function fireEvents(data, utm_source) {
    var pt_pagetype = "seite";
    var pt_conversion_orderid = "";
    var pt_conversion_total = "";
    var pt_productname = "";
    var pt_productid = "";
    var dataScript = data.script;
    var uc_adition = (0, $alJys.getUcService)(data.adition);
    var uc_xandr = (0, $alJys.getUcService)(data.xandr);
    var uc_google_analytics = (0, $alJys.getUcService)(data.ga);
    var sessPagetype = sessionStorage.getItem("pt_pagetype");
    if (sessPagetype) pt_pagetype = sessPagetype;
    var sessConvOrderid = sessionStorage.getItem("pt_conversion_orderid");
    if (sessConvOrderid) pt_conversion_orderid = sessConvOrderid;
    var sessConvTotal = sessionStorage.getItem("pt_conversion_total");
    if (sessConvTotal) pt_conversion_total = sessConvTotal;
    var sessProductName = sessionStorage.getItem("pt_productname");
    if (sessProductName) pt_productname = sessProductName;
    var sessProductId = sessionStorage.getItem("pt_productid");
    if (sessProductId) pt_productid = sessProductId;
    if (pt_pagetype == "seite") {
        var donation_form = document.querySelector(".custom-donation");
        if (!donation_form) donation_form = document.querySelector("#donation-step-1");
        if (donation_form) {
            pt_pagetype = "spendenformular";
            var dataLayer = window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                pt: {
                    pagetype: "spendenformular"
                }
            });
        }
    }
    if (typeof window.utm268 === "undefined") {
        window.utm268 = {};
        window.utm268.data = {
            /* Settings General */ advertiser_id: "adv_m_".concat(data.id),
            // do not change
            pt_pagetype: pt_pagetype,
            // insert pagetype, possible values: 'home', 'product', 'category', 'conversion'
            /* Conversion */ pt_conversion_orderid: pt_conversion_orderid,
            // insert your order ID or unique identifer (mandatory)
            pt_conversion_total: pt_conversion_total,
            // insert value of basket (optional)
            pt_conversion_quantity: "",
            // insert number of purchased products (optional)
            pt_conversion_success: "",
            // if Lasttouch / deduplication (Cookie-Weiche) insert 1, for hardcoded 0; Default 0
            /* Settings Categories */ pt_category: "",
            // insert main category
            pt_subcategory1: "",
            // insert subcategory 1
            /* Settings Product */ pt_productname: pt_productname,
            // insert product name
            pt_productid: pt_productid,
            // insert product id
            /* Settings Marketing_Channels */ pt_channel: utm_source,
            // insert channel for visit or conversion
            /* Settings Custom Variables */ pt_customvar1: uc_adition,
            // insert value for defined customvar1
            pt_customvar2: uc_google_analytics,
            // insert value for defined customvar2
            pt_customvar3: uc_xandr,
            // insert value for defined customvar3
            pt_customvar4: "",
            // insert value for defined customvar4
            pt_customvar5: "",
            // insert value for defined customvar5
            pt_customvar6: "",
            // insert value for defined customvar6
            pt_customvar7: "",
            // insert value for defined customvar7
            pt_customvar8: "",
            // insert value for defined customvar8
            pt_customvar9: "",
            // insert value for defined customvar9
            pt_customvar10: "",
            // insert value for defined customvar10
            /* Do not change */ pt_loc: decodeURI(document.location.href),
            // do not change
            pt_ref: decodeURI(document.referrer),
            // do not change
            pt_protocol: "https:" == document.location.protocol ? "https://" : "http://",
            // do not change
            pt_cachebuster: new Date().getTime() // do not change
        };
        $b45483ed49b147c3$var$utm(window, document, "script", dataScript, "utm268");
    }
};
var $b45483ed49b147c3$var$init = module.exports.init = function init() {
    var rootElement = document.querySelector("#scriptUTT");
    var rootData = rootElement.dataset;
    var rootUC = rootData.piamedia;
    var url = window.location.href;
    var utm_source = null;
    // search all given keys
    var keyToFind = "utm_source";
    /// is there a utm source ?
    if (url.indexOf(keyToFind + "=") > -1) utm_source = url.substr(url.indexOf(keyToFind + "=") + keyToFind.length + 1).split("&")[0];
    else utm_source = sessionStorage.getItem("utm_source");
    var attempts = 0;
    var _whenComplete = /*#__PURE__*/ function() {
        var _ref = $b45483ed49b147c3$var$_asyncToGenerator(/*#__PURE__*/ $b45483ed49b147c3$var$_regeneratorRuntime().mark(function _callee() {
            return $b45483ed49b147c3$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (!(++attempts > 30)) {
                            _context.next = 2;
                            break;
                        }
                        return _context.abrupt("return");
                    case 2:
                        _context.next = 4;
                        return (0, $alJys.checkUcInit)();
                    case 4:
                        if (!_context.sent) {
                            _context.next = 8;
                            break;
                        }
                        if ((0, $alJys.getUcService)(rootUC)) $b45483ed49b147c3$var$fireEvents(rootData, utm_source);
                        _context.next = 9;
                        break;
                    case 8:
                        setTimeout(function() {
                            return _whenComplete();
                        }, 500);
                    case 9:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function whenComplete() {
            return _ref.apply(this, arguments);
        };
    }();
    _whenComplete();
    document.addEventListener("asuc-updated", function() {
        if ((0, $alJys.getUcService)(rootUC)) $b45483ed49b147c3$var$fireEvents(rootData, utm_source);
    });
};

});


//# sourceMappingURL=utt.module.bcd59a32.js.map
